import { Stack, Tabs, Text, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";

import { GrantsTab } from "@/features/discounts/ui/grants-tab";
import { OffersTab } from "@/features/discounts/ui/offers-tab";
import { PositionsTab } from "@/features/discounts/ui/positions-tab";

export function DiscountsPage() {
	const { t } = useTranslation();
	const [params, setParams] = useSearchParams();
	const tab = params.get("tab") ?? "offers";

	return (
		<Stack gap="md">
			<div>
				<Title order={2}>{t("discounts.title")}</Title>
				<Text c="dimmed" size="sm">
					{t("discounts.subtitleLive")}
				</Text>
			</div>

			<Tabs
				value={tab}
				onChange={(value) => {
					const next = new URLSearchParams(params);
					next.set("tab", value as string);
					setParams(next, { replace: true });
				}}
			>
				<Tabs.List style={{ flexWrap: "nowrap", overflowX: "auto" }}>
					<Tabs.Tab value="offers">{t("discounts.tabOffers")}</Tabs.Tab>
					<Tabs.Tab value="positions">{t("discounts.tabPositions")}</Tabs.Tab>
					<Tabs.Tab value="grants">{t("discounts.tabGrants")}</Tabs.Tab>
				</Tabs.List>
				<Tabs.Panel value="offers" pt="md">
					<OffersTab />
				</Tabs.Panel>
				<Tabs.Panel value="positions" pt="md">
					<PositionsTab />
				</Tabs.Panel>
				<Tabs.Panel value="grants" pt="md">
					<GrantsTab />
				</Tabs.Panel>
			</Tabs>
		</Stack>
	);
}
